module.exports = __webpack_public_path__ + "static/media/pool.20d58753.jpg";